// extracted by mini-css-extract-plugin
module.exports = {"nome-destinatario":"Registro_nome-destinatario__2o-7T","corpo-texto":"Registro_corpo-texto__2yLVI"};